const MAGNIFIER = 'M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z';

/** The button a zoomable figure carries. */
export default function ZoomTrigger({ onOpen }: { readonly onOpen: () => void }) @{
  <button
    type="button"
    class="docs-zoom-trigger"
    aria-label="Open in zoom view"
    onClick={(event: MouseEvent) => {
      event.stopPropagation();
      onOpen();
    }}
  >
    <svg viewBox="0 0 20 20" fill="currentColor" width="13" height="13" aria-hidden="true"><path d={MAGNIFIER}></path></svg>
    <span>Zoom</span>
  </button>
}
